/* Ezlo Halloween Shop (sections/hlw-*.liquid): "Add to cart" ([data-hlw-add] = one variant id) and "add them all"
   ([data-hlw-add-all] = ids, comma separated) post to /cart/add.js; the header (nav-header) catches that and opens its cart.
   The button says Added for a moment. Every section loads this file (defer); the guard makes the next ones no-ops. */
(function () {
  if (window.__hlwCart) return;
  window.__hlwCart = true;
  function add(btn, items) {
    var label = btn.textContent;
    var back = function () { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; };
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { btn.textContent = 'Added'; btn.classList.add('is-added'); setTimeout(back, 2200); })
      .catch(function () { btn.textContent = 'Not available'; setTimeout(back, 2200); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.hlw [data-hlw-add], .hlw [data-hlw-add-all]'); if (!b || b.disabled) return;
    e.preventDefault();
    var ids = b.hasAttribute('data-hlw-add-all') ? b.getAttribute('data-hlw-add-all').split(',') : [b.getAttribute('data-hlw-add')];
    add(b, ids.filter(Boolean).map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }));
  });
  /* the line-up: the rest of the cards waits for "See all" */
  var openLineup = function () {
    var l = document.querySelector('[data-hlw-lineup]'); if (!l) return;
    l.classList.add('is-open');
    var b = l.querySelector('[data-hlw-lineup-open]'); if (b) b.setAttribute('aria-expanded', 'true');
  };
  var initLineup = function () { var l = document.querySelector('[data-hlw-lineup]'); if (l) l.classList.add('is-js'); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLineup); else initLineup();
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-hlw-lineup-open]')) openLineup(); });
  /* links inside the page (#hlw-picks, #hlw-lineup) glide there; the line-up link opens it all too */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.hlw a[href^="#hlw-"]'); if (!a) return;
    var t = document.querySelector(a.getAttribute('href')); if (!t) return;
    e.preventDefault();
    if (a.getAttribute('href') === '#hlw-lineup') openLineup();
    t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
})();
